export default {
  'pagePaymentSuccess.success.title': 'Gia hạn thành công',
  'pagePaymentSuccess.success.desc': 'Chúc mừng bạn đã thành công gia hạn gói cước hiện tại.',
  'pagePaymentSuccess.success.button': 'Xem lịch sử thanh toán',
  'pagePaymentSuccess.fail.title': 'Gia hạn thất bại',
  'pagePaymentSuccess.fail.desc': 'Gia hạn gói cước của bạn đã thất bại.',
  'pagePaymentSuccess.fail.button': 'Thử lại',
};
